// NOTE: All endpoints goes here

export const AdminManagement = {
    getAdmins: `/admin/admins`,
    getAdminById: (id: string) => `/admin/admins/${id}?include_user_role=true`,
    updateAdminDetails: (id: string) => `/admin/admins/${id}`,
    updateAdminRole: (id: string) => `/admin/user-roles/${id}`,
    assignAdminRole: `/admin/user-roles`,
    getAdminRoles: `/admin/roles`,
    removeAdminRole: (id: string) => `/admin/user-roles/${id}`,
    getRolesOfUser: `/admin/user-roles`,
    // Role-Permission endpoints as per API documentation
    assignRolePermission: `/admin/role-permissions`,
    getRolePermissions: `/admin/role-permissions`,
    updateRolePermission: (id: string) => `/admin/role-permissions/${id}`,
    removeRolePermission: (id: string) => `/admin/role-permissions/${id}`,
    // Legacy endpoint for backward compatibility
    getPermissions: `/admin/role-permissions`,
};

export const cards = {
    dispatchACard: `/admin/cards-dispatch`,
    getCard: (id: string) => `/admin/cards/${id}`,
    getCards: `/admin/cards`,
    createPhysicalCard: `/admin/physical-cards`,
};

export const audit = {
    getAuditLogs: `/admin/audit-logs`,
    getAuditLogById: (id: string) => `/admin/audit-logs/${id}`,
};

export const transactions = '/admin/transactions';

export const notifications = {
  getNotifications: '/admin/notifications',
  getNotificationById: (id: string) => `/admin/notifications/${id}`,
  resendNotification: (id: string) => `/notifications/${id}`,
  authenticateChannel: '/notification-channel-tokens',
};
